// extracted by mini-css-extract-plugin
export var chevronIcon = "_92-2";
export var teamName = "_92-1";
export var teamSwitcherButton = "_92-0";